import { defineMessages } from 'react-intl';

const trns = defineMessages({
  formLabel: {
    id: 'JzkYg3',
    defaultMessage: 'Лікарська форма'
  },
  doseLabel: {
    id: 'LaUpWq',
    defaultMessage: 'Дозування'
  },
  packagingLabel: {
    id: 'Vo4SiT',
    defaultMessage: 'Фасування'
  },
  makerLabel: {
    id: 'W4PjS1',
    defaultMessage: 'Виробник'
  },
  priceInStoresLabel: {
    id: 'tQ2Un/',
    defaultMessage: 'Ціна в аптеках:'
  },
  economyLabel: {
    id: 'Tka+TR',
    defaultMessage: '*Економія при броні з LikiE {discount} ₴ '
  },
  foundInStoresLabel: {
    id: 'MyMVcf',
    defaultMessage: 'Знайдено в {count} аптеках {city}'
  },
  nearStoresLabel: {
    id: 'qiq4ec',
    defaultMessage: 'Ми обрали {bestStores} з найнижчими цінами поруч.'
  },
  сhooseLabel: {
    id: 'U9Omam',
    defaultMessage: 'Вибір'
  },
  bestStoresLabel: {
    id: '9bQ9Qv',
    defaultMessage: 'найкращу аптеку'
  },
  instructionLabel: {
    id: 'nUOiFb',
    defaultMessage: 'Інструкція'
  },
  notInStock: {
    id: 'qENd0c',
    defaultMessage: 'Немає в наявності'
  },
  priceLabelFrom: {
    id: 'NkDqtO',
    defaultMessage: 'від {price}'
  },
  countLabel: {
    id: 'jipWTS',
    defaultMessage: 'є в {count} аптеках'
  },
  toListButton: {
    id: 'jwa9ID',
    defaultMessage: 'У список'
  },
  notifyAvailable: {
    id: 'gFqWww',
    defaultMessage: 'Повідомити'
  },
  inListLabel: {
    id: 'Wm3l4A',
    defaultMessage: 'У списку'
  },
  addToList: {
    id: 'TfLCGY',
    defaultMessage: 'У список товарів'
  },
  addDrugToCart: {
    id: '9rlAC8',
    defaultMessage: 'Додати'
  },
  alreadyInList: {
    id: 'mqkiwz',
    defaultMessage: 'У списку товарів'
  },
  remind: {
    id: 'sQkTZw',
    defaultMessage: 'Коли з’явиться'
  },
  notify: {
    id: 'gFqWww',
    defaultMessage: 'Повідомити'
  },
  selectTheShop: {
    id: 'Zx8Koz',
    defaultMessage: 'Обрати аптеку'
  },
  itemAddToCart: {
    id: 'y588jY',
    defaultMessage: 'Товар доданий в список товарів'
  }
});

export default trns;
